export const translations = {
    it: {
        // Header & Navigation
        dashboard: "Dashboard",
        scanner: "Scanner",
        analysis: "Analisi",
        checklist: "Checklist",
        journal: "Diario",
        history: "Storico",
        accounts: "Account",
        report: "Report",
        profile: "Profilo",
        settings: "Impostazioni",
        logout: "Disconnetti",

        // MT5 Status
        mt5_connected: "MT5 Connesso",
        mt5_disconnected: "MT5 Disconnesso",

        // Session Scanner
        session_scanner: "Scanner Sessioni",
        auto_scanner_active: "Auto-Scanner Attivo",
        auto_scanner_desc: "Scan automatico ogni 15 minuti (08:00-00:00)",
        next_scan: "Prossimo scan tra",
        no_setups: "Nessun Setup Trovato",
        no_setups_desc: "Non ci sono setup validi al momento. Riprova più tardi.",
        ready_to_scan: "Monitoraggio Automatico in Corso",
        ready_to_scan_desc: "⚠️ Disclaimer: Il sistema scansiona automaticamente il mercato ogni 15 minuti. Attendi il prossimo aggiornamento.",
        ready_to_scan_tip: "💡 Consiglio: I risultati più affidabili si ottengono solitamente tra le 08:00 e le 13:00.",
        top_setups: "TOP SETUPS",
        watch_list: "WATCH LIST",
        analyze: "ANALIZZA",
        analyzing: "Analizzando",
        automatic_analysis: "Analisi automatica delle migliori opportunità",
        next_session: "Prossima",

        // MT5 Accounts
        mt5_accounts: "Account MT5",
        manage_mt5_connections: "Gestisci le connessioni ai tuoi account MetaTrader 5",
        add_account: "Aggiungi Account",
        add_mt5_account: "Aggiungi Account MT5",
        account_number: "Numero Account",
        server: "Server",
        login: "Login",
        password: "Password",
        nickname_optional: "Nickname (opzionale)",
        connected: "Connesso",
        disconnected: "Disconnesso",
        active: "Attivo",
        inactive: "Inattivo",
        sync: "Sincronizza",
        remove: "Rimuovi",
        last_sync: "Ultimo sync",
        sync_error: "Errore sync",
        never: "Mai",
        just_now: "Adesso",
        minutes_ago: "min fa",
        hours_ago: "h fa",
        days_ago: "g fa",
        connecting: "Connessione in corso...",
        loading_accounts: "Caricamento account...",
        no_accounts_connected: "Nessun Account Connesso",
        add_first_account_desc: "Aggiungi il tuo primo account MT5 per iniziare a sincronizzare i trades",
        confirm_remove_account: "Sei sicuro di voler rimuovere questo account MT5?",
        auto_sync_info: "Sync automatico ogni 3 ore.",
        auto_sync_desc: "I tuoi trades vengono sincronizzati automaticamente in background. Puoi anche forzare un sync manuale cliccando sull'icona refresh.",

        // AI Deep Analysis
        ai_deep_analysis: "Analisi Avanzata AI",
        ai_analysis_desc: "Analisi approfondita con AI e setup automatico",
        ai_analysis_qualified_desc: "Analisi avanzata con AI per setup qualificati (65%+)",
        ai_analysis: "ANALISI AI",
        request_analysis: "Richiedi Analisi AI",
        request_deep_analysis: "Richiedi Analisi AI Approfondita",
        analyzing_with_ai: "Analizzando con AI...",
        analysis_complete: "Analisi Completata",
        save_to_history: "Salva nello Storico",
        entry_price: "Prezzo di Entrata",
        stop_loss: "Stop Loss",
        take_profit: "Take Profit",
        risk_reward: "Risk/Reward",
        confidence: "Confidenza",
        select_pair: "Seleziona una coppia",
        select_pair_desc: "Scegli una coppia dalla sidebar o usa lo Scanner per trovare i migliori setup",
        setup_not_qualified: "Setup Non Qualificato",
        current_score: "Score attuale",
        need_score: "Serve",
        for_ai_analysis: "per l'analisi AI",
        suggestion: "Suggerimento",
        use_scanner_tip: "Usa lo Scanner per trovare coppie con score 65%+ già pronte per l'analisi AI approfondita",
        no_valid_setup: "Nessun Setup Valido",
        no_consecutive_tf: "non ha timeframe consecutivi allineati",
        reload: "Ricarica",
        original_score: "Score Originale",
        ai_adjusted_score: "Score AI Adjusted",
        key_points: "Punti Chiave",
        risks_to_consider: "Rischi da Considerare",
        saving: "Salvando...",
        signal_saved: "Segnale Salvato!",
        regenerate_analysis: "Rigenera Analisi",

        // Profile
        your_profile: "Il tuo Profilo",
        manage_preferences: "Gestisci le tue preferenze e il tuo account",
        language: "Lingua / Language",
        account_info: "Informazioni Account",
        account_details: "Dettagli Account",
        account_details_desc: "Email, Password, Sicurezza",
        advanced_settings: "Impostazioni Avanzate",
        password_security: "Password e Sicurezza",
        back_to_settings: "Torna alle Impostazioni",
        email: "Email",
        member_since: "Membro dal",
        account_status: "Stato Account",
        verified: "Verificato",
        unverified: "Non Verificato",
        not_set: "Non impostato",
        not_available: "Non disponibile",

        // Sidebar
        live: "Live",
        today: "Oggi",
        open: "Aperte",

        // Common
        loading: "Caricamento...",
        error: "Errore",
        success: "Successo",
        save: "Salva",
        cancel: "Annulla",
        close: "Chiudi",
        confirm: "Conferma",

        // Strategies Page
        strategies_title: "Strategies / Checklist",
        strategies_description: "Seleziona la strategia da utilizzare per lo scanner automatico. Ogni strategia ha parametri e soglie specifiche.",
        strategies_loading: "Caricamento strategie...",
        strategies_load_error: "Errore nel caricamento delle strategie",
        strategies_change_error: "Errore nel cambiare strategia",
        strategies_changed_to: "Strategia cambiata a {name}",
        strategies_frequency: "Frequenza",
        strategies_rr_target: "RR Target",
        strategies_entry_threshold: "Entry Threshold",
        strategies_max_points: "Max Points",
        strategies_requires_liquidity_sweep: "Richiede sweep di liquidità",
        strategies_requires_all_core: "Richiede TUTTI i punti CORE",
        strategies_active: "ATTIVA",
        strategies_use_this: "USARE QUESTA STRATEGIA",
        strategies_already_active: "Questa strategia è già attiva",
        strategies_footer_info: "💡 La strategia selezionata verrà utilizzata dallo scanner automatico per identificare i setup validi. Puoi cambiare strategia in qualsiasi momento.",

        // Pricing Features
        pricing_feature_auto_scanner: "Auto Scanner 24/7",
        pricing_feature_calculator: "Calcolatore Pips/Lot Size",
        pricing_feature_all_currencies: "Tutte le valute (tranne la TOP oscurata)",
        pricing_feature_top_obscured_note: "La valuta con score più alto è oscurata",
        pricing_feature_one_ai: "1 Analisi AI Deep al giorno (totale)",
        pricing_feature_one_ai_note: "Non per valuta, ma totale giornaliero",
        pricing_feature_leaderboard: "Leaderboard con top setup",
        pricing_feature_basic_history: "Storico segnali base",
        pricing_feature_top_unlocked: "Tutte le valute TOP sbloccate",
        pricing_feature_multiple_ai: "Analisi AI multiple",
        pricing_feature_priority_support: "Support prioritario",
        pricing_feature_advanced_reports: "Report PDF avanzati",
        pricing_feature_all_free: "Tutto del piano Free",
        pricing_feature_three_ai: "3 Analisi AI Deep per valuta al giorno",
        pricing_feature_three_ai_note: "Per ogni valuta, 3 analisi al giorno",
        pricing_feature_advanced_checklist: "Checklist avanzata completa",
        pricing_feature_ml_engine: "ML Prediction Engine",
        pricing_feature_full_history: "Storico completo con performance tracking",
        pricing_feature_detailed_reports: "Report PDF dettagliati",
        pricing_feature_real_time_notifications: "Notifiche real-time",
        pricing_feature_email_support: "Support via email",
        pricing_feature_unlimited_ai: "Analisi AI ILLIMITATE",
        pricing_feature_24_7_support: "Support prioritario 24/7",
        pricing_feature_all_pro: "Tutto del piano Pro",
        pricing_feature_advanced_backtest: "Backtest automatico avanzato",
        pricing_feature_api_access: "API access per integrazioni",
        pricing_feature_multi_account: "Multi-account MT5 avanzato",
        pricing_feature_custom_alerts: "Custom alerts e webhooks",
        pricing_feature_personalized_training: "Training personalizzato",
        pricing_feature_beta_access: "Accesso beta features",
        pricing_feature_dedicated_manager: "Account manager dedicato",

        // How It Works
        how_works_step1_title: "Registrati Gratis",
        how_works_step1_desc: "Crea il tuo account in 30 secondi. Non serve carta di credito per iniziare.",
        how_works_step1_detail1: "Registrazione in 30 secondi",
        how_works_step1_detail2: "Nessuna carta di credito richiesta",
        how_works_step1_detail3: "Accesso immediato al piano Free",
        how_works_step1_detail4: "Tutorial interattivo incluso",
        how_works_step2_title: "Scegli la tua Strategia",
        how_works_step2_desc: "Seleziona tra 4 strategie di trading professionali, ognuna ottimizzata per stili diversi.",
        how_works_step2_detail1: "4 strategie professionali disponibili",
        how_works_step2_detail2: "Parametri ottimizzati per ogni strategia",
        how_works_step2_detail3: "Cambio strategia istantaneo",
        how_works_step2_detail4: "Nuove strategie in arrivo",
        how_works_step3_title: "Usa lo Scanner",
        how_works_step3_desc: "Lo scanner automatico trova i migliori setup ogni 15 minuti. Vedi la leaderboard sempre aggiornata.",
        how_works_step3_detail1: "Scan automatico ogni 15 minuti",
        how_works_step3_detail2: "50+ simboli analizzati",
        how_works_step3_detail3: "Leaderboard in tempo reale",
        how_works_step3_detail4: "Filtri per score e direzione",
        how_works_step4_title: "Analizza e Trade",
        how_works_step4_desc: "Analizza i setup migliori, richiedi analisi AI per validazione e gestisci i trade con SL/TP automatici.",
        how_works_step4_detail1: "Checklist avanzata multi-timeframe",
        how_works_step4_detail2: "Analisi AI per setup qualificati",
        how_works_step4_detail3: "Calcolo automatico SL/TP",
        how_works_step4_detail4: "Monitoraggio performance",

        // Tutorial Steps
        tutorial_step1_title: "Registrati e Inizia",
        tutorial_step1_content: "Crea il tuo account in pochi secondi. Scegli la strategia che preferisci e inizia ad analizzare il mercato.",
        tutorial_step2_title: "Esplora lo Scanner",
        tutorial_step2_content: "Vai alla sezione Scanner per vedere la leaderboard con i migliori setup. I risultati si aggiornano automaticamente ogni 15 minuti.",
        tutorial_step3_title: "Analizza un Setup",
        tutorial_step3_content: "Clicca su una valuta per vedere: score dettagliato, trend multi-timeframe, Order Blocks, FVG, e tutti i criteri della checklist avanzata.",
        tutorial_step4_title: "Richiedi Analisi AI",
        tutorial_step4_content: "Per setup con score ≥65%, puoi richiedere un'analisi AI Deep che ti fornisce: validazione setup, SL/TP ottimali, entry timing e raccomandazione finale.",
        tutorial_step5_title: "Monitora i Segnali",
        tutorial_step5_content: "I segnali salvati vengono monitorati automaticamente. Ricevi notifiche quando TP o SL vengono raggiunti. Vedi le performance in tempo reale.",
        tutorial_step6_title: "Esporta e Analizza",
        tutorial_step6_content: "Esporta report PDF dettagliati, analizza lo storico dei segnali, calcola statistiche di performance e impara dai risultati per migliorare.",

        // Use Cases
        use_case_day_trader_title: "Trader Giornaliero",
        use_case_day_trader_desc: "Per chi fa trading intraday e cerca setup di alta qualità durante le sessioni attive",
        use_case_day_trader_benefit1: "Scanner ogni 15 minuti durante le sessioni",
        use_case_day_trader_benefit2: "Notifiche real-time per setup top",
        use_case_day_trader_benefit3: "Analisi AI per entry timing ottimale",
        use_case_day_trader_benefit4: "Monitoraggio TP/SL automatico",
        use_case_day_trader_result: "Risparmia 3-4 ore al giorno di analisi manuale",
        use_case_swing_title: "Swing Trader",
        use_case_swing_desc: "Per chi tiene posizioni per giorni/settimane e cerca setup con alta confluence",
        use_case_swing_benefit1: "Analisi multi-timeframe (W1, D1, H4)",
        use_case_swing_benefit2: "Identificazione trend principali",
        use_case_swing_benefit3: "Order Blocks e FVG su timeframe alti",
        use_case_swing_benefit4: "Risk:Reward ottimizzato per swing",
        use_case_swing_result: "Aumenta precisione entry del 40%+",
        use_case_scalper_title: "Scalper",
        use_case_scalper_desc: "Per chi fa molti trade al giorno e ha bisogno di segnali rapidi e precisi",
        use_case_scalper_benefit1: "Leaderboard sempre aggiornata",
        use_case_scalper_benefit2: "Filtri per score minimo personalizzabili",
        use_case_scalper_benefit3: "Analisi AI rapide per conferma",
        use_case_scalper_benefit4: "Calcolatore lot size integrato",
        use_case_scalper_result: "Riduce falsi segnali del 35%",
        use_case_part_time_title: "Trader Part-Time",
        use_case_part_time_desc: "Per chi ha poco tempo ma vuole trading professionale senza dedicare ore all'analisi",
        use_case_part_time_benefit1: "Scanner automatico 24/7",
        use_case_part_time_benefit2: "Setup già validati e pronti",
        use_case_part_time_benefit3: "Report PDF per analisi offline",
        use_case_part_time_benefit4: "Storico completo per review",
        use_case_part_time_result: "Trading professionale in 30 minuti al giorno",
        use_case_professional_title: "Trader Professionale",
        use_case_professional_desc: "Per trader istituzionali che gestiscono capitali importanti e necessitano di precisione massima",
        use_case_professional_benefit1: "ML Prediction Engine avanzato",
        use_case_professional_benefit2: "Backtest automatico su storico",
        use_case_professional_benefit3: "Multi-account MT5 management",
        use_case_professional_benefit4: "API access per integrazioni",
        use_case_professional_result: "Gestione professionale di portafogli complessi",
        use_case_learning_title: "Trader in Apprendimento",
        use_case_learning_desc: "Per chi sta imparando e vuole capire come i professionisti analizzano i mercati",
        use_case_learning_benefit1: "Checklist dettagliata con spiegazioni",
        use_case_learning_benefit2: "Analisi AI educative",
        use_case_learning_benefit3: "Storico con performance tracking",
        use_case_learning_benefit4: "Pattern recognition spiegato",
        use_case_learning_result: "Impara strategie professionali velocemente",

        // Testimonials
        testimonial_marco_name: "Marco T.",
        testimonial_marco_role: "Trader Professionale",
        testimonial_marco_location: "Milano, Italia",
        testimonial_marco_text: "Ho aumentato il mio win rate del 35% in soli 2 mesi. Lo scanner automatico mi fa risparmiare almeno 4 ore al giorno di analisi. Le analisi AI sono incredibilmente accurate.",
        testimonial_marco_highlight: "Win rate +35% in 2 mesi",
        testimonial_sarah_name: "Sarah K.",
        testimonial_sarah_role: "Swing Trader",
        testimonial_sarah_location: "Roma, Italia",
        testimonial_sarah_text: "Finalmente un tool che combina analisi tecnica avanzata con AI. I setup che mi suggerisce hanno un Risk:Reward medio di 1:2.5. Il monitoraggio automatico TP/SL è un game changer.",
        testimonial_sarah_highlight: "R:R medio 1:2.5",
        testimonial_luca_name: "Luca R.",
        testimonial_luca_role: "Trader Part-Time",
        testimonial_luca_location: "Torino, Italia",
        testimonial_luca_text: "Lavoro full-time e faccio trading la sera. TradeAnalyzer Pro mi permette di avere setup professionali pronti quando torno a casa. Ho triplicato il numero di trade profittevoli.",
        testimonial_luca_highlight: "Trade profittevoli x3",
        testimonial_elena_name: "Elena M.",
        testimonial_elena_role: "Trader in Apprendimento",
        testimonial_elena_location: "Firenze, Italia",
        testimonial_elena_text: "Sto imparando il trading da 6 mesi. Questo tool mi ha insegnato più di qualsiasi corso. Vedo come i professionisti analizzano i mercati e applico le stesse strategie.",
        testimonial_elena_highlight: "Apprendimento accelerato",
        testimonial_andrea_name: "Andrea B.",
        testimonial_andrea_role: "Scalper",
        testimonial_andrea_location: "Napoli, Italia",
        testimonial_andrea_text: "Faccio 10-15 trade al giorno. Lo scanner mi dà solo i setup migliori, eliminando i falsi segnali. La precisione è aumentata del 40% e ho ridotto le perdite significativamente.",
        testimonial_andrea_highlight: "Precisione +40%",
        testimonial_giulia_name: "Giulia F.",
        testimonial_giulia_role: "Trader Forex",
        testimonial_giulia_location: "Bologna, Italia",
        testimonial_giulia_text: "L'integrazione MT5 è perfetta. Vedo tutto in un unico dashboard: setup, posizioni, performance. Il calcolo automatico SL/TP basato su struttura di mercato è geniale.",
        testimonial_giulia_highlight: "Workflow ottimizzato",

        // FAQs
        faq_how_scanner_works_q: "Come funziona lo scanner automatico?",
        faq_how_scanner_works_a: "Lo scanner analizza automaticamente 50+ simboli ogni 15 minuti (dalle 08:00 alle 00:00 ora italiana). Usa una checklist avanzata multi-timeframe per calcolare un score da 0% a 175%+. Solo setup con score ≥65% vengono salvati nella leaderboard.",
        faq_top_obscured_q: "Cosa significa \"valuta TOP oscurata\" nel piano Free?",
        faq_top_obscured_a: "Nel piano Free, la valuta con il score più alto nella leaderboard viene oscurata per incentivare l'upgrade. Tutte le altre valute sono visibili e analizzabili. Con il piano Pro, tutte le valute sono sbloccate.",
        faq_ai_analysis_free_q: "Quante analisi AI posso fare con il piano Free?",
        faq_ai_analysis_free_a: "Con il piano Free hai 1 analisi AI Deep al giorno in totale (non per valuta). Con Pro hai 3 analisi per valuta al giorno. Con Advanced hai analisi illimitate.",
        faq_mt5_required_q: "È necessario collegare MT5?",
        faq_mt5_required_a: "Sì, per sfruttare tutte le funzionalità di TradeAnalyzer Pro è necessario collegare un account MetaTrader 5. Questo permette di avere dati real-time, monitoraggio automatico TP/SL, sincronizzazione posizioni e analisi accurate basate sui tuoi dati di trading.",
        faq_score_calculation_q: "Come viene calcolato lo score?",
        faq_score_calculation_a: "Lo score è calcolato su 5 timeframe: Weekly (60pt), Daily (40pt), H4 (40pt), Intraday (15pt), Entry Signals (20pt). Il totale può superare 100% grazie ai bonus per confluence e pattern avanzati.",
        faq_change_plan_q: "Posso cambiare piano in qualsiasi momento?",
        faq_change_plan_a: "Sì, puoi upgrade o downgrade in qualsiasi momento. I cambiamenti sono immediati. Se fai downgrade, mantieni l'accesso fino alla fine del periodo pagato.",

        // Asset Categories
        asset_forex_majors: "Forex Majors",
        asset_forex_crosses: "Forex Crosses",
        asset_precious_metals: "Metalli Preziosi",
        asset_cryptocurrencies: "Criptovalute",
        asset_indices: "Indici",

        // Landing Page
        landing_nav_features: "Funzionalità",
        landing_nav_how_it_works: "Come Funziona",
        landing_nav_use_cases: "Casi d'Uso",
        landing_nav_testimonials: "Testimonianze",
        landing_nav_tutorial: "Tutorial",
        landing_nav_pricing: "Prezzi",
        landing_nav_login: "Accedi",
        landing_powered_by: "Powered by AI • Claude 4.5 + DeepSeek",
        landing_hero_title_1: "Analisi di Trading",
        landing_hero_title_2: "Professionale con AI",
        landing_hero_subtitle: "Scanner automatico 24/7, analisi multi-timeframe avanzata, integrazione MT5 e AI ibrida per decisioni di trading informate e profittevoli",
        landing_hero_benefit: "Risparmia 10+ ore a settimana. Aumenta la precisione del 40%. Gestisci il rischio automaticamente.",
        landing_start_free: "Inizia Gratis",
        landing_see_plans: "Vedi Piani",
        landing_stats_symbols: "Simboli Analizzati",
        landing_stats_scan: "Scan Automatico",
        landing_stats_score: "Score Massimo",
        landing_stats_rr: "Risk:Reward Min",
        landing_scroll_more: "Scorri per saperne di più",
        landing_benefit_save_time: "Risparmia 10+ ore/settimana",
        landing_benefit_precision: "Precisione +40%",
        landing_benefit_risk: "Gestione Rischio Automatica",
        landing_benefit_tracking: "Monitoraggio 24/7",
        landing_features_title: "Funzionalità",
        landing_features_title_highlight: "Potenti",
        landing_features_subtitle: "Tutto ciò di cui hai bisogno per un trading professionale",
        landing_feature_ai_title: "AI Ibrida Avanzata",
        landing_feature_ai_desc: "Analisi AI con Claude 4.5 e DeepSeek per identificare pattern complessi e suggerire setup ottimali",
        landing_feature_scanner_title: "Scanner Automatico",
        landing_feature_scanner_desc: "Scanner automatico ogni 15 minuti (08:00-00:00 ora italiana) che analizza 50+ simboli in parallelo. Leaderboard sempre aggiornata con i migliori setup ordinati per confluence score.",
        landing_feature_strategies_title: "4 Strategie Avanzate",
        landing_feature_strategies_desc: "Scegli tra 4 strategie di trading professionali, ognuna con parametri ottimizzati. Altre strategie in arrivo!",
        landing_feature_risk_title: "Gestione Rischio",
        landing_feature_risk_desc: "Calcolatore pips avanzato per valute, indici e metalli. Calcolo automatico di stop loss e take profit con risk/reward ottimale",
        landing_feature_monitor_title: "Monitoraggio Real-time",
        landing_feature_monitor_desc: "Monitoraggio continuo del mercato con notifiche istantanee via WebSocket per non perdere mai un'opportunità",
        landing_feature_tools_title: "Strumenti Automatici Avanzati",
        landing_feature_tools_desc: "Strumenti intelligenti che analizzano automaticamente il mercato: identificazione zone chiave, trend multi-timeframe, aree di interesse e molto altro",
        landing_feature_detail_scan_auto: "Scan automatico ogni 15 minuti",
        landing_feature_detail_symbols_parallel: "50+ simboli analizzati in parallelo",
        landing_feature_detail_leaderboard_realtime: "Leaderboard aggiornata in tempo reale",
        landing_feature_detail_filters: "Filtri avanzati per setup qualificati",
        landing_feature_detail_4_strategies: "4 strategie pronte all'uso",
        landing_feature_detail_more_coming: "Nuove strategie in arrivo",
        landing_feature_detail_custom_params: "Parametri personalizzati per strategia",
        landing_feature_detail_auto_switch: "Cambio strategia istantaneo",
        landing_feature_detail_auto_tpsl: "Calcolo automatico TP/SL",
        landing_feature_detail_auto_sltp: "Stop Loss e Take Profit automatici",
        landing_feature_detail_asset_adaptation: "Adattamento automatico per asset",
        landing_feature_detail_websocket: "Connessione WebSocket real-time",
        landing_feature_detail_instant_notifications: "Notifiche istantanee",
        landing_feature_detail_checklist_12: "Checklist AI a 12 punti",
        landing_feature_detail_backtest: "Backtesting avanzato",
        landing_feature_detail_exportable_pdf: "Report esportabili in PDF",
        landing_assets_title: "Asset",
        landing_assets_supported: "Supportati",
        landing_assets_desc: "Supporto completo per Forex, Metalli Preziosi, Criptovalute e Indici",
        landing_assets_and_more: "E molto altro",
        landing_assets_full_support: "con calcolatore pips avanzato integrato",
        landing_how_it_works_title: "Come",
        landing_how_it_works_funziona: "Funziona",
        landing_how_it_works_desc: "Quattro semplici passaggi per iniziare a fare trading professionale con AI",
        landing_use_cases_title: "Per",
        landing_use_cases_every_trader: "Ogni Trader",
        landing_use_cases_desc: "Dai principianti ai professionisti, la nostra piattaforma si adatta alle tue esigenze",
        landing_testimonials_title: "Cosa Dicono i",
        landing_testimonials_traders: "Trader",
        landing_testimonials_desc: "Testimonianze reali da trader che usano la nostra piattaforma",
        landing_testimonials_plan_label: "Piano",
        landing_testimonials_active_traders: "Trader Attivi",
        landing_testimonials_avg_rating: "Valutazione Media",
        landing_testimonials_satisfaction: "Soddisfazione",
        landing_tutorial_title: "Tutorial",
        landing_tutorial_step_by_step: "Passo dopo Passo",
        landing_tutorial_desc: "Impara a usare tutte le funzionalità della piattaforma in pochi minuti",
        landing_tutorial_start: "Inizia Tutorial",
        landing_pricing_title: "Piani e Prezzi",
        landing_pricing_subtitle: "Scegli il piano perfetto per le tue esigenze di trading",
        landing_pricing_free_name: "Free",
        landing_pricing_free_period: "Gratis per sempre",
        landing_pricing_free_desc: "Perfetto per iniziare",
        landing_pricing_free_cta: "Inizia Gratis",
        landing_pricing_pro_name: "Pro",
        landing_pricing_pro_period: "€29/mese",
        landing_pricing_pro_desc: "Per trader seri",
        landing_pricing_pro_cta: "Scegli Pro",
        landing_pricing_advanced_name: "Advanced",
        landing_pricing_advanced_period: "€29.90/mese",
        landing_pricing_advanced_desc: "Per professionisti",
        landing_pricing_advanced_cta: "Scegli Advanced",
        landing_pricing_most_popular: "PIÙ POPOLARE",
        landing_pricing_secure: "Pagamento sicuro e garantito",
        landing_faqs_title: "Domande",
        landing_faqs_frequent: "Frequenti",
        landing_faqs_desc: "Risposte alle domande più comuni sulla nostra piattaforma",
        landing_cta_title: "Pronto a Iniziare?",
        landing_cta_subtitle: "Unisciti a migliaia di trader che usano la nostra piattaforma ogni giorno",
        landing_footer_description: "Analisi di trading professionale powered by AI. Scanner automatico, analisi multi-timeframe e 4 strategie avanzate.",
        landing_footer_product: "Prodotto",
        landing_footer_resources: "Risorse",
        landing_footer_documentation: "Documentazione",
        landing_footer_api: "API",
        landing_footer_support: "Supporto",
        landing_footer_security: "Sicurezza",
        landing_footer_encrypted_data: "Dati criptati",
        landing_footer_gdpr: "Conformità GDPR",
        landing_footer_secure_servers: "Server sicuri",
        landing_footer_copyright: "© 2024 TradeAnalyzer Pro. All rights reserved.",
        landing_auth_back: "Torna alla Home",
        landing_auth_create_account: "Crea il tuo account",
        landing_auth_login_account: "Accedi al tuo account",
        landing_auth_start_today: "Inizia oggi e trasforma il tuo trading",
        landing_auth_welcome_back: "Bentornato! Accedi per continuare",
        landing_auth_have_account: "Hai già un account?",
        landing_auth_sign_in: "Accedi",
        landing_auth_no_account: "Non hai un account?",
        landing_auth_sign_up: "Registrati"
    },
    en: {
        // Header & Navigation
        dashboard: "Dashboard",
        scanner: "Scanner",
        analysis: "Analysis",
        checklist: "Checklist",
        journal: "Journal",
        history: "History",
        accounts: "Accounts",
        report: "Report",
        profile: "Profile",
        settings: "Settings",
        logout: "Logout",

        // MT5 Status
        mt5_connected: "MT5 Connected",
        mt5_disconnected: "MT5 Disconnected",

        // Session Scanner
        session_scanner: "Session Scanner",
        auto_scanner_active: "Auto-Scanner Active",
        auto_scanner_desc: "Automatic scan every 15 minutes (08:00-00:00)",
        next_scan: "Next scan in",
        no_setups: "No Setups Found",
        no_setups_desc: "There are no valid setups at the moment. Try again later.",
        ready_to_scan: "Automatic Monitoring in Progress",
        ready_to_scan_desc: "⚠️ Disclaimer: The system automatically scans the market every 15 minutes. Wait for the next update.",
        ready_to_scan_tip: "💡 Tip: The most reliable results are usually obtained between 08:00 and 13:00.",
        top_setups: "TOP SETUPS",
        watch_list: "WATCH LIST",
        analyze: "ANALYZE",
        analyzing: "Analyzing",
        automatic_analysis: "Automatic analysis of the best opportunities",
        next_session: "Next",

        // MT5 Accounts
        mt5_accounts: "MT5 Accounts",
        manage_mt5_connections: "Manage connections to your MetaTrader 5 accounts",
        add_account: "Add Account",
        add_mt5_account: "Add MT5 Account",
        account_number: "Account Number",
        server: "Server",
        login: "Login",
        password: "Password",
        nickname_optional: "Nickname (optional)",
        connected: "Connected",
        disconnected: "Disconnected",
        active: "Active",
        inactive: "Inactive",
        sync: "Sync",
        remove: "Remove",
        last_sync: "Last sync",
        sync_error: "Sync error",
        never: "Never",
        just_now: "Just now",
        minutes_ago: "min ago",
        hours_ago: "h ago",
        days_ago: "d ago",
        connecting: "Connecting...",
        loading_accounts: "Loading accounts...",
        no_accounts_connected: "No Accounts Connected",
        add_first_account_desc: "Add your first MT5 account to start syncing trades",
        confirm_remove_account: "Are you sure you want to remove this MT5 account?",
        auto_sync_info: "Auto sync every 3 hours.",
        auto_sync_desc: "Your trades are automatically synced in the background. You can also force a manual sync by clicking the refresh icon.",

        // AI Deep Analysis
        ai_deep_analysis: "AI Deep Analysis",
        ai_analysis_desc: "In-depth analysis with AI and automatic setup",
        ai_analysis_qualified_desc: "Advanced AI analysis for qualified setups (65%+)",
        ai_analysis: "AI ANALYSIS",
        request_analysis: "Request AI Analysis",
        request_deep_analysis: "Request Deep AI Analysis",
        analyzing_with_ai: "Analyzing with AI...",
        analysis_complete: "Analysis Complete",
        save_to_history: "Save to History",
        entry_price: "Entry Price",
        stop_loss: "Stop Loss",
        take_profit: "Take Profit",
        risk_reward: "Risk/Reward",
        confidence: "Confidence",
        select_pair: "Select a pair",
        select_pair_desc: "Choose a pair from the sidebar or use the Scanner to find the best setups",
        setup_not_qualified: "Setup Not Qualified",
        current_score: "Current score",
        need_score: "Need",
        for_ai_analysis: "for AI analysis",
        suggestion: "Suggestion",
        use_scanner_tip: "Use the Scanner to find pairs with 65%+ score ready for deep AI analysis",
        no_valid_setup: "No Valid Setup",
        no_consecutive_tf: "does not have consecutive aligned timeframes",
        reload: "Reload",
        original_score: "Original Score",
        ai_adjusted_score: "AI Adjusted Score",
        key_points: "Key Points",
        risks_to_consider: "Risks to Consider",
        saving: "Saving...",
        signal_saved: "Signal Saved!",
        regenerate_analysis: "Regenerate Analysis",

        // Profile
        your_profile: "Your Profile",
        manage_preferences: "Manage your preferences and account",
        language: "Language / Lingua",
        account_info: "Account Information",
        account_details: "Account Details",
        account_details_desc: "Email, Password, Security",
        advanced_settings: "Advanced Settings",
        password_security: "Password and Security",
        back_to_settings: "Back to Settings",
        email: "Email",
        member_since: "Member since",
        account_status: "Account Status",
        verified: "Verified",
        unverified: "Unverified",
        not_set: "Not set",
        not_available: "Not available",

        // Sidebar
        live: "Live",
        today: "Today",
        open: "Open",

        // Common
        loading: "Loading...",
        error: "Error",
        success: "Success",
        save: "Save",
        cancel: "Cancel",
        close: "Close",
        confirm: "Confirm",

        // Strategies Page
        strategies_title: "Strategies / Checklist",
        strategies_description: "Select the strategy to use for the automatic scanner. Each strategy has specific parameters and thresholds.",
        strategies_loading: "Loading strategies...",
        strategies_load_error: "Error loading strategies",
        strategies_change_error: "Error changing strategy",
        strategies_changed_to: "Strategy changed to {name}",
        strategies_frequency: "Frequency",
        strategies_rr_target: "RR Target",
        strategies_entry_threshold: "Entry Threshold",
        strategies_max_points: "Max Points",
        strategies_requires_liquidity_sweep: "Requires liquidity sweep",
        strategies_requires_all_core: "Requires ALL CORE points",
        strategies_active: "ACTIVE",
        strategies_use_this: "USE THIS STRATEGY",
        strategies_already_active: "This strategy is already active",
        strategies_footer_info: "💡 The selected strategy will be used by the automatic scanner to identify valid setups. You can change strategy at any time.",

        // Landing Page
        landing_nav_features: "Funzionalità",
        landing_nav_how_it_works: "Come Funziona",
        landing_nav_use_cases: "Casi d'Uso",
        landing_nav_testimonials: "Testimonianze",
        landing_nav_tutorial: "Tutorial",
        landing_nav_pricing: "Prezzi",
        landing_nav_login: "Accedi",
        landing_powered_by: "Powered by AI • Claude 4.5 + DeepSeek",
        landing_hero_title_1: "Analisi di Trading",
        landing_hero_title_2: "Professionale con AI",
        landing_hero_subtitle: "Scanner automatico 24/7, analisi multi-timeframe avanzata, integrazione MT5 e AI ibrida per decisioni di trading informate e profittevoli",
        landing_hero_benefit: "Risparmia 10+ ore a settimana. Aumenta la precisione del 40%. Gestisci il rischio automaticamente.",
        landing_start_free: "Inizia Gratis",
        landing_see_plans: "Vedi Piani",
        landing_stats_symbols: "Simboli Analizzati",
        landing_stats_scan: "Scan Automatico",
        landing_stats_score: "Score Massimo",
        landing_stats_rr: "Risk:Reward Min",
        landing_scroll_more: "Scorri per saperne di più",
        landing_benefit_save_time: "Risparmia 10+ ore/settimana",
        landing_benefit_precision: "Precisione +40%",
        landing_benefit_risk: "Gestione Rischio Automatica",
        landing_benefit_tracking: "Monitoraggio 24/7",
        landing_features_title: "Funzionalità",
        landing_features_title_highlight: "Potenti",
        landing_features_subtitle: "Tutto ciò di cui hai bisogno per un trading professionale",
        landing_feature_ai_title: "AI Ibrida Avanzata",
        landing_feature_ai_desc: "Analisi AI con Claude 4.5 e DeepSeek per identificare pattern complessi e suggerire setup ottimali",
        landing_feature_scanner_title: "Scanner Automatico",
        landing_feature_scanner_desc: "Scanner automatico ogni 15 minuti (08:00-00:00 ora italiana) che analizza 50+ simboli in parallelo. Leaderboard sempre aggiornata con i migliori setup ordinati per confluence score.",
        landing_feature_strategies_title: "4 Strategie Avanzate",
        landing_feature_strategies_desc: "Scegli tra 4 strategie di trading professionali, ognuna con parametri ottimizzati. Altre strategie in arrivo!",
        landing_feature_risk_title: "Gestione Rischio",
        landing_feature_risk_desc: "Calcolatore pips avanzato per valute, indici e metalli. Calcolo automatico di stop loss e take profit con risk/reward ottimale",
        landing_feature_monitor_title: "Monitoraggio Real-time",
        landing_feature_monitor_desc: "Monitoraggio continuo del mercato con notifiche istantanee via WebSocket per non perdere mai un'opportunità",
        landing_feature_tools_title: "Strumenti Automatici Avanzati",
        landing_feature_tools_desc: "Strumenti intelligenti che analizzano automaticamente il mercato: identificazione zone chiave, trend multi-timeframe, aree di interesse e molto altro",
        landing_feature_detail_scan_auto: "Scan automatico ogni 15 minuti",
        landing_feature_detail_symbols_parallel: "50+ simboli analizzati in parallelo",
        landing_feature_detail_leaderboard_realtime: "Leaderboard aggiornata in tempo reale",
        landing_feature_detail_filters: "Filtri avanzati per setup qualificati",
        landing_feature_detail_4_strategies: "4 strategie pronte all'uso",
        landing_feature_detail_more_coming: "Nuove strategie in arrivo",
        landing_feature_detail_custom_params: "Parametri personalizzati per strategia",
        landing_feature_detail_auto_switch: "Cambio strategia istantaneo",
        landing_feature_detail_auto_tpsl: "Calcolo automatico TP/SL",
        landing_feature_detail_auto_sltp: "Stop Loss e Take Profit automatici",
        landing_feature_detail_asset_adaptation: "Adattamento automatico per asset",
        landing_feature_detail_websocket: "Connessione WebSocket real-time",
        landing_feature_detail_instant_notifications: "Notifiche istantanee",
        landing_feature_detail_checklist_12: "Checklist AI a 12 punti",
        landing_feature_detail_backtest: "Backtesting avanzato",
        landing_feature_detail_exportable_pdf: "Report esportabili in PDF",
        landing_assets_title: "Asset",
        landing_assets_supported: "Supportati",
        landing_assets_desc: "Supporto completo per Forex, Metalli Preziosi, Criptovalute e Indici",
        landing_assets_and_more: "E molto altro",
        landing_assets_full_support: "con calcolatore pips avanzato integrato",
        landing_how_it_works_title: "Come",
        landing_how_it_works_funziona: "Funziona",
        landing_how_it_works_desc: "Quattro semplici passaggi per iniziare a fare trading professionale con AI",
        landing_use_cases_title: "Per",
        landing_use_cases_every_trader: "Ogni Trader",
        landing_use_cases_desc: "Dai principianti ai professionisti, la nostra piattaforma si adatta alle tue esigenze",
        landing_testimonials_title: "Cosa Dicono i",
        landing_testimonials_traders: "Trader",
        landing_testimonials_desc: "Testimonianze reali da trader che usano la nostra piattaforma",
        landing_testimonials_plan_label: "Piano",
        landing_testimonials_active_traders: "Trader Attivi",
        landing_testimonials_avg_rating: "Valutazione Media",
        landing_testimonials_satisfaction: "Soddisfazione",
        landing_tutorial_title: "Tutorial",
        landing_tutorial_step_by_step: "Passo dopo Passo",
        landing_tutorial_desc: "Impara a usare tutte le funzionalità della piattaforma in pochi minuti",
        landing_tutorial_start: "Inizia Tutorial",
        landing_pricing_title: "Piani e Prezzi",
        landing_pricing_subtitle: "Scegli il piano perfetto per le tue esigenze di trading",
        landing_pricing_free_name: "Free",
        landing_pricing_free_period: "Gratis per sempre",
        landing_pricing_free_desc: "Perfetto per iniziare",
        landing_pricing_free_cta: "Inizia Gratis",
        landing_pricing_pro_name: "Pro",
        landing_pricing_pro_period: "€29/mese",
        landing_pricing_pro_desc: "Per trader seri",
        landing_pricing_pro_cta: "Scegli Pro",
        landing_pricing_advanced_name: "Advanced",
        landing_pricing_advanced_period: "€29.90/mese",
        landing_pricing_advanced_desc: "Per professionisti",
        landing_pricing_advanced_cta: "Scegli Advanced",
        landing_pricing_most_popular: "PIÙ POPOLARE",
        landing_pricing_secure: "Pagamento sicuro e garantito",
        landing_faqs_title: "Domande",
        landing_faqs_frequent: "Frequenti",
        landing_faqs_desc: "Risposte alle domande più comuni sulla nostra piattaforma",
        landing_cta_title: "Pronto a Iniziare?",
        landing_cta_subtitle: "Unisciti a migliaia di trader che usano la nostra piattaforma ogni giorno",
        landing_footer_description: "Analisi di trading professionale powered by AI. Scanner automatico, analisi multi-timeframe e 4 strategie avanzate.",
        landing_footer_product: "Prodotto",
        landing_footer_resources: "Risorse",
        landing_footer_documentation: "Documentazione",
        landing_footer_api: "API",
        landing_footer_support: "Supporto",
        landing_footer_security: "Sicurezza",
        landing_footer_encrypted_data: "Dati criptati",
        landing_footer_gdpr: "Conformità GDPR",
        landing_footer_secure_servers: "Server sicuri",
        landing_footer_copyright: "© 2024 TradeAnalyzer Pro. All rights reserved.",
        landing_auth_back: "Torna alla Home",
        landing_auth_create_account: "Crea il tuo account",
        landing_auth_login_account: "Accedi al tuo account",
        landing_auth_start_today: "Inizia oggi e trasforma il tuo trading",
        landing_auth_welcome_back: "Bentornato! Accedi per continuare",
        landing_auth_have_account: "Hai già un account?",
        landing_auth_sign_in: "Accedi",
        landing_auth_no_account: "Non hai un account?",
        landing_auth_sign_up: "Registrati",
        now: "Ora"
    },
    en: {
        // Header & Navigation
        dashboard: "Dashboard",
        scanner: "Scanner",
        analysis: "Analysis",
        checklist: "Checklist",
        journal: "Journal",
        history: "History",
        accounts: "Accounts",
        report: "Report",
        profile: "Profile",
        settings: "Settings",
        logout: "Logout",

        // MT5 Status
        mt5_connected: "MT5 Connected",
        mt5_disconnected: "MT5 Disconnected",

        // Session Scanner
        session_scanner: "Session Scanner",
        auto_scanner_active: "Auto-Scanner Active",
        auto_scanner_desc: "Automatic scan every 15 minutes (08:00-00:00)",
        next_scan: "Next scan in",
        no_setups: "No Setups Found",
        no_setups_desc: "No valid setups at the moment. Try again later.",
        ready_to_scan: "Automatic Monitoring in Progress",
        ready_to_scan_desc: "⚠️ Disclaimer: The system automatically scans the market every 15 minutes. Wait for the next update.",
        ready_to_scan_tip: "💡 Tip: The most reliable results are usually obtained between 08:00 and 13:00.",
        top_setups: "TOP SETUPS",
        watch_list: "WATCH LIST",
        analyze: "ANALYZE",
        analyzing: "Analyzing",
        automatic_analysis: "Automatic analysis of the best opportunities",
        next_session: "Next",

        // MT5 Accounts
        mt5_accounts: "MT5 Accounts",
        manage_mt5_connections: "Manage your MetaTrader 5 account connections",
        add_account: "Add Account",
        add_mt5_account: "Add MT5 Account",
        account_number: "Account Number",
        server: "Server",
        login: "Login",
        password: "Password",
        nickname_optional: "Nickname (optional)",
        connected: "Connected",
        disconnected: "Disconnected",
        active: "Active",
        inactive: "Inactive",
        sync: "Sync",
        remove: "Remove",
        last_sync: "Last sync",
        sync_error: "Sync error",
        never: "Never",
        just_now: "Just now",
        minutes_ago: "min ago",
        hours_ago: "h ago",
        days_ago: "d ago",
        connecting: "Connecting...",
        loading_accounts: "Loading accounts...",
        no_accounts_connected: "No Accounts Connected",
        add_first_account_desc: "Add your first MT5 account to start syncing trades",
        confirm_remove_account: "Are you sure you want to remove this MT5 account?",
        auto_sync_info: "Auto sync every 3 hours.",
        auto_sync_desc: "Your trades are automatically synced in the background. You can also force a manual sync by clicking the refresh icon.",

        // AI Deep Analysis
        ai_deep_analysis: "AI Deep Analysis",
        ai_analysis_desc: "In-depth analysis with AI and automatic setup",
        ai_analysis_qualified_desc: "Advanced AI analysis for qualified setups (65%+)",
        ai_analysis: "AI ANALYSIS",
        request_analysis: "Request AI Analysis",
        request_deep_analysis: "Request Deep AI Analysis",
        analyzing_with_ai: "Analyzing with AI...",
        analysis_complete: "Analysis Complete",
        save_to_history: "Save to History",
        entry_price: "Entry Price",
        stop_loss: "Stop Loss",
        take_profit: "Take Profit",
        risk_reward: "Risk/Reward",
        confidence: "Confidence",
        select_pair: "Select a pair",
        select_pair_desc: "Choose a pair from the sidebar or use the Scanner to find the best setups",
        setup_not_qualified: "Setup Not Qualified",
        current_score: "Current score",
        need_score: "Need",
        for_ai_analysis: "for AI analysis",
        suggestion: "Suggestion",
        use_scanner_tip: "Use the Scanner to find pairs with 65%+ score ready for deep AI analysis",
        no_valid_setup: "No Valid Setup",
        no_consecutive_tf: "does not have consecutive aligned timeframes",
        reload: "Reload",
        original_score: "Original Score",
        ai_adjusted_score: "AI Adjusted Score",
        key_points: "Key Points",
        risks_to_consider: "Risks to Consider",
        saving: "Saving...",
        signal_saved: "Signal Saved!",
        regenerate_analysis: "Regenerate Analysis",

        // Profile
        your_profile: "Your Profile",
        manage_preferences: "Manage your preferences and account",
        language: "Language / Lingua",
        account_info: "Account Information",
        account_details: "Account Details",
        account_details_desc: "Email, Password, Security",
        advanced_settings: "Advanced Settings",
        password_security: "Password and Security",
        back_to_settings: "Back to Settings",
        email: "Email",
        member_since: "Member since",
        account_status: "Account Status",
        verified: "Verified",
        unverified: "Unverified",
        not_set: "Not set",
        not_available: "Not available",

        // Sidebar
        live: "Live",
        today: "Today",
        open: "Open",

        // Common
        loading: "Loading...",
        error: "Error",
        success: "Success",
        save: "Save",
        cancel: "Cancel",
        close: "Close",
        confirm: "Confirm",

        // Strategies Page
        strategies_title: "Strategies / Checklist",
        strategies_description: "Select the strategy to use for the automatic scanner. Each strategy has specific parameters and thresholds.",
        strategies_loading: "Loading strategies...",
        strategies_load_error: "Error loading strategies",
        strategies_change_error: "Error changing strategy",
        strategies_changed_to: "Strategy changed to {name}",
        strategies_frequency: "Frequency",
        strategies_rr_target: "RR Target",
        strategies_entry_threshold: "Entry Threshold",
        strategies_max_points: "Max Points",
        strategies_requires_liquidity_sweep: "Requires liquidity sweep",
        strategies_requires_all_core: "Requires ALL CORE points",
        strategies_active: "ACTIVE",
        strategies_use_this: "USE THIS STRATEGY",
        strategies_already_active: "This strategy is already active",
        strategies_footer_info: "💡 The selected strategy will be used by the automatic scanner to identify valid setups. You can change strategy at any time.",

        // Landing Page
        landing_nav_features: "Features",
        landing_nav_how_it_works: "How It Works",
        landing_nav_use_cases: "Use Cases",
        landing_nav_testimonials: "Testimonials",
        landing_nav_tutorial: "Tutorial",
        landing_nav_pricing: "Pricing",
        landing_nav_login: "Login",
        landing_powered_by: "Powered by AI • Claude 4.5 + DeepSeek",
        landing_hero_title_1: "Professional Trading",
        landing_hero_title_2: "Analysis with AI",
        landing_hero_subtitle: "24/7 automatic scanner, advanced multi-timeframe analysis, MT5 integration and hybrid AI for informed and profitable trading decisions",
        landing_hero_benefit: "Save 10+ hours per week. Increase accuracy by 40%. Manage risk automatically.",
        landing_start_free: "Start Free",
        landing_see_plans: "See Plans",
        landing_stats_symbols: "Symbols Analyzed",
        landing_stats_scan: "Automatic Scan",
        landing_stats_score: "Max Score",
        landing_stats_rr: "Min Risk:Reward",
        landing_scroll_more: "Scroll for more",
        landing_benefit_save_time: "Save 10+ hours/week",
        landing_benefit_precision: "Precision +40%",
        landing_benefit_risk: "Automatic Risk Management",
        landing_benefit_tracking: "24/7 Monitoring",
        landing_features_title: "Features",
        landing_features_title_highlight: "Powerful",
        landing_features_subtitle: "Everything you need for professional trading",
        landing_feature_ai_title: "Advanced Hybrid AI",
        landing_feature_ai_desc: "AI analysis with Claude 4.5 and DeepSeek to identify complex patterns and suggest optimal setups",
        landing_feature_scanner_title: "Automatic Scanner",
        landing_feature_scanner_desc: "Automatic scanner every 15 minutes (08:00-00:00 Italian time) that analyzes 50+ symbols in parallel. Leaderboard always updated with the best setups sorted by confluence score.",
        landing_feature_strategies_title: "4 Advanced Strategies",
        landing_feature_strategies_desc: "Choose from 4 professional trading strategies, each with optimized parameters. More strategies coming soon!",
        landing_feature_risk_title: "Risk Management",
        landing_feature_risk_desc: "Advanced pips calculator for currencies, indices and metals. Automatic stop loss and take profit calculation with optimal risk/reward",
        landing_feature_monitor_title: "Real-time Monitoring",
        landing_feature_monitor_desc: "Continuous market monitoring with instant notifications via WebSocket to never miss an opportunity",
        landing_feature_tools_title: "Advanced Automatic Tools",
        landing_feature_tools_desc: "Smart tools that automatically analyze the market: key zone identification, multi-timeframe trends, areas of interest and much more",
        landing_feature_detail_scan_auto: "Automatic scan every 15 minutes",
        landing_feature_detail_symbols_parallel: "50+ symbols analyzed in parallel",
        landing_feature_detail_leaderboard_realtime: "Real-time updated leaderboard",
        landing_feature_detail_filters: "Advanced filters for qualified setups",
        landing_feature_detail_4_strategies: "4 strategies ready to use",
        landing_feature_detail_more_coming: "New strategies coming soon",
        landing_feature_detail_custom_params: "Custom parameters per strategy",
        landing_feature_detail_auto_switch: "Instant strategy switching",
        landing_feature_detail_auto_tpsl: "Automatic TP/SL calculation",
        landing_feature_detail_auto_sltp: "Automatic Stop Loss and Take Profit",
        landing_feature_detail_asset_adaptation: "Automatic adaptation for asset",
        landing_feature_detail_websocket: "Real-time WebSocket connection",
        landing_feature_detail_instant_notifications: "Instant notifications",
        landing_feature_detail_checklist_12: "12-point AI checklist",
        landing_feature_detail_backtest: "Advanced backtesting",
        landing_feature_detail_exportable_pdf: "Exportable PDF reports",
        landing_assets_title: "Supported",
        landing_assets_supported: "Assets",
        landing_assets_desc: "Full support for Forex, Precious Metals, Cryptocurrencies and Indices",
        landing_assets_and_more: "And much more",
        landing_assets_full_support: "with advanced pips calculator integrated",
        landing_how_it_works_title: "How It",
        landing_how_it_works_funziona: "Works",
        landing_how_it_works_desc: "Four simple steps to start professional trading with AI",
        landing_use_cases_title: "For Every",
        landing_use_cases_every_trader: "Trader",
        landing_use_cases_desc: "From beginners to professionals, our platform adapts to your needs",
        landing_testimonials_title: "What",
        landing_testimonials_traders: "Traders Say",
        landing_testimonials_desc: "Real testimonials from traders using our platform",
        landing_testimonials_plan_label: "Plan",
        landing_testimonials_active_traders: "Active Traders",
        landing_testimonials_avg_rating: "Average Rating",
        landing_testimonials_satisfaction: "Satisfaction",
        landing_tutorial_title: "Step by Step",
        landing_tutorial_step_by_step: "Tutorial",
        landing_tutorial_desc: "Learn to use all platform features in a few minutes",
        landing_tutorial_start: "Start Tutorial",
        landing_pricing_title: "Plans & Pricing",
        landing_pricing_subtitle: "Choose the perfect plan for your trading needs",
        landing_pricing_free_name: "Free",
        landing_pricing_free_period: "Free forever",
        landing_pricing_free_desc: "Perfect to get started",
        landing_pricing_free_cta: "Start Free",
        landing_pricing_pro_name: "Pro",
        landing_pricing_pro_period: "€29/month",
        landing_pricing_pro_desc: "For serious traders",
        landing_pricing_pro_cta: "Choose Pro",
        landing_pricing_advanced_name: "Advanced",
        landing_pricing_advanced_period: "€99/month",
        landing_pricing_advanced_desc: "For professionals",
        landing_pricing_advanced_cta: "Choose Advanced",
        landing_pricing_most_popular: "MOST POPULAR",
        landing_pricing_secure: "Secure and guaranteed payment",
        landing_faqs_title: "Frequently Asked",
        landing_faqs_frequent: "Questions",
        landing_faqs_desc: "Answers to the most common questions about our platform",
        landing_cta_title: "Ready to Start?",
        landing_cta_subtitle: "Join thousands of traders using our platform every day",
        landing_footer_description: "Professional trading analysis powered by AI. Automatic scanner, multi-timeframe analysis and 4 advanced strategies.",
        landing_footer_product: "Product",
        landing_footer_resources: "Resources",
        landing_footer_documentation: "Documentation",
        landing_footer_api: "API",
        landing_footer_support: "Support",
        landing_footer_security: "Security",
        landing_footer_encrypted_data: "Encrypted data",
        landing_footer_gdpr: "GDPR Compliance",
        landing_footer_secure_servers: "Secure servers",
        landing_footer_copyright: "© 2024 TradeAnalyzer Pro. All rights reserved.",
        landing_auth_back: "Back to Home",
        landing_auth_create_account: "Create your account",
        landing_auth_login_account: "Login to your account",
        landing_auth_start_today: "Start today and transform your trading",
        landing_auth_welcome_back: "Welcome back! Login to continue",
        landing_auth_have_account: "Already have an account?",
        landing_auth_sign_in: "Sign In",
        landing_auth_no_account: "Don't have an account?",
        landing_auth_sign_up: "Sign Up",
        now: "Now"
    },
    es: {
        // Header & Navigation
        dashboard: "Panel",
        scanner: "Escáner",
        analysis: "Análisis",
        checklist: "Lista de Verificación",
        journal: "Diario",
        history: "Historial",
        accounts: "Cuentas",
        report: "Informe",
        profile: "Perfil",
        settings: "Configuración",
        logout: "Cerrar Sesión",

        // MT5 Status
        mt5_connected: "MT5 Conectado",
        mt5_disconnected: "MT5 Desconectado",

        // Session Scanner
        session_scanner: "Escáner de Sesiones",
        auto_scanner_active: "Auto-Escáner Activo",
        auto_scanner_desc: "Escaneo automático cada 15 minutos (08:00-00:00)",
        next_scan: "Próximo escaneo en",
        no_setups: "No se Encontraron Setups",
        no_setups_desc: "No hay setups válidos en este momento. Inténtalo más tarde.",
        ready_to_scan: "Monitoreo Automático en Curso",
        ready_to_scan_desc: "⚠️ Descargo de responsabilidad: El sistema escanea automáticamente el mercado cada 15 minutos. Espera la próxima actualización.",
        ready_to_scan_tip: "💡 Consejo: Los resultados más confiables generalmente se obtienen entre las 08:00 y las 13:00.",
        top_setups: "TOP SETUPS",
        watch_list: "LISTA DE SEGUIMIENTO",
        analyze: "ANALIZAR",
        analyzing: "Analizando",
        automatic_analysis: "Análisis automático de las mejores oportunidades",
        next_session: "Próxima",

        // MT5 Accounts
        mt5_accounts: "Cuentas MT5",
        manage_mt5_connections: "Gestiona las conexiones a tus cuentas MetaTrader 5",
        add_account: "Añadir Cuenta",
        add_mt5_account: "Añadir Cuenta MT5",
        account_number: "Número de Cuenta",
        server: "Servidor",
        login: "Inicio de Sesión",
        password: "Contraseña",
        nickname_optional: "Apodo (opcional)",
        connected: "Conectado",
        disconnected: "Desconectado",
        active: "Activo",
        inactive: "Inactivo",
        sync: "Sincronizar",
        remove: "Eliminar",
        last_sync: "Última sincronización",
        sync_error: "Error de sincronización",
        never: "Nunca",
        just_now: "Ahora mismo",
        minutes_ago: "min atrás",
        hours_ago: "h atrás",
        days_ago: "d atrás",
        connecting: "Conectando...",
        loading_accounts: "Cargando cuentas...",
        no_accounts_connected: "No hay Cuentas Conectadas",
        add_first_account_desc: "Añade tu primera cuenta MT5 para comenzar a sincronizar operaciones",
        confirm_remove_account: "¿Estás seguro de que quieres eliminar esta cuenta MT5?",
        auto_sync_info: "Sincronización automática cada 3 horas.",
        auto_sync_desc: "Tus operaciones se sincronizan automáticamente en segundo plano. También puedes forzar una sincronización manual haciendo clic en el icono de actualizar.",

        // AI Deep Analysis
        ai_deep_analysis: "Análisis Profundo con IA",
        ai_analysis_desc: "Análisis en profundidad con IA y configuración automática",
        ai_analysis_qualified_desc: "Análisis avanzado con IA para setups calificados (65%+)",
        ai_analysis: "ANÁLISIS IA",
        request_analysis: "Solicitar Análisis IA",
        request_deep_analysis: "Solicitar Análisis Profundo con IA",
        analyzing_with_ai: "Analizando con IA...",
        analysis_complete: "Análisis Completado",
        save_to_history: "Guardar en Historial",
        entry_price: "Precio de Entrada",
        stop_loss: "Stop Loss",
        take_profit: "Take Profit",
        risk_reward: "Riesgo/Recompensa",
        confidence: "Confianza",
        select_pair: "Selecciona un par",
        select_pair_desc: "Elige un par de la barra lateral o usa el Escáner para encontrar los mejores setups",
        setup_not_qualified: "Setup No Calificado",
        current_score: "Puntuación actual",
        need_score: "Necesitas",
        for_ai_analysis: "para el análisis IA",
        suggestion: "Sugerencia",
        use_scanner_tip: "Usa el Escáner para encontrar pares con puntuación 65%+ listos para el análisis profundo con IA",
        no_valid_setup: "No hay Setup Válido",
        no_consecutive_tf: "no tiene timeframes consecutivos alineados",
        reload: "Recargar",
        original_score: "Puntuación Original",
        ai_adjusted_score: "Puntuación Ajustada por IA",
        key_points: "Puntos Clave",
        risks_to_consider: "Riesgos a Considerar",
        saving: "Guardando...",
        signal_saved: "¡Señal Guardada!",
        regenerate_analysis: "Regenerar Análisis",

        // Profile
        your_profile: "Tu Perfil",
        manage_preferences: "Gestiona tus preferencias y cuenta",
        language: "Idioma / Language",
        account_info: "Información de la Cuenta",
        account_details: "Detalles de la Cuenta",
        account_details_desc: "Correo, Contraseña, Seguridad",
        advanced_settings: "Configuración Avanzada",
        password_security: "Contraseña y Seguridad",
        back_to_settings: "Volver a Configuración",
        email: "Correo",
        member_since: "Miembro desde",
        account_status: "Estado de la Cuenta",
        verified: "Verificado",
        unverified: "No Verificado",
        not_set: "No establecido",
        not_available: "No disponible",

        // Sidebar
        live: "En Vivo",
        today: "Hoy",
        open: "Abiertas",

        // Common
        loading: "Cargando...",
        error: "Error",
        success: "Éxito",
        save: "Guardar",
        cancel: "Cancelar",
        close: "Cerrar",
        confirm: "Confirmar",

        // Strategies Page
        strategies_title: "Estrategias / Lista de Verificación",
        strategies_description: "Selecciona la estrategia a utilizar para el escáner automático. Cada estrategia tiene parámetros y umbrales específicos.",
        strategies_loading: "Cargando estrategias...",
        strategies_load_error: "Error al cargar las estrategias",
        strategies_change_error: "Error al cambiar la estrategia",
        strategies_changed_to: "Estrategia cambiada a {name}",
        strategies_frequency: "Frecuencia",
        strategies_rr_target: "Objetivo RR",
        strategies_entry_threshold: "Umbral de Entrada",
        strategies_max_points: "Puntos Máximos",
        strategies_requires_liquidity_sweep: "Requiere barrido de liquidez",
        strategies_requires_all_core: "Requiere TODOS los puntos CORE",
        strategies_active: "ACTIVA",
        strategies_use_this: "USAR ESTA ESTRATEGIA",
        strategies_already_active: "Esta estrategia ya está activa",
        strategies_footer_info: "💡 La estrategia seleccionada será utilizada por el escáner automático para identificar setups válidos. Puedes cambiar de estrategia en cualquier momento.",

        // Landing Page
        landing_nav_features: "Características",
        landing_nav_how_it_works: "Cómo Funciona",
        landing_nav_use_cases: "Casos de Uso",
        landing_nav_testimonials: "Testimonios",
        landing_nav_tutorial: "Tutorial",
        landing_nav_pricing: "Precios",
        landing_nav_login: "Iniciar Sesión",
        landing_powered_by: "Powered by AI • Claude 4.5 + DeepSeek",
        landing_hero_title_1: "Análisis de Trading",
        landing_hero_title_2: "Profesional con IA",
        landing_hero_subtitle: "Escáner automático 24/7, análisis multi-timeframe avanzado, integración MT5 e IA híbrida para decisiones de trading informadas y rentables",
        landing_hero_benefit: "Ahorra 10+ horas por semana. Aumenta la precisión en un 40%. Gestiona el riesgo automáticamente.",
        landing_start_free: "Empezar Gratis",
        landing_see_plans: "Ver Planes",
        landing_stats_symbols: "Símbolos Analizados",
        landing_stats_scan: "Escaneo Automático",
        landing_stats_score: "Puntuación Máxima",
        landing_stats_rr: "Riesgo:Recompensa Mín",
        landing_scroll_more: "Desplázate para más",
        landing_benefit_save_time: "Ahorra 10+ horas/semana",
        landing_benefit_precision: "Precisión +40%",
        landing_benefit_risk: "Gestión de Riesgo Automática",
        landing_benefit_tracking: "Monitoreo 24/7",
        landing_features_title: "Características",
        landing_features_title_highlight: "Potentes",
        landing_features_subtitle: "Todo lo que necesitas para un trading profesional",
        landing_feature_ai_title: "IA Híbrida Avanzada",
        landing_feature_ai_desc: "Análisis con IA usando Claude 4.5 y DeepSeek para identificar patrones complejos y sugerir configuraciones óptimas",
        landing_feature_scanner_title: "Escáner Automático",
        landing_feature_scanner_desc: "Escáner automático cada 15 minutos (08:00-00:00 hora italiana) que analiza 50+ símbolos en paralelo. Tabla de clasificación siempre actualizada con las mejores configuraciones ordenadas por puntuación de confluencia.",
        landing_feature_strategies_title: "4 Estrategias Avanzadas",
        landing_feature_strategies_desc: "Elige entre 4 estrategias de trading profesionales, cada una con parámetros optimizados. ¡Más estrategias próximamente!",
        landing_feature_risk_title: "Gestión de Riesgo",
        landing_feature_risk_desc: "Calculador de pips avanzado para divisas, índices y metales. Cálculo automático de stop loss y take profit con riesgo/recompensa óptimo",
        landing_feature_monitor_title: "Monitoreo en Tiempo Real",
        landing_feature_monitor_desc: "Monitoreo continuo del mercado con notificaciones instantáneas vía WebSocket para no perder nunca una oportunidad",
        landing_feature_tools_title: "Herramientas Automáticas Avanzadas",
        landing_feature_tools_desc: "Herramientas inteligentes que analizan automáticamente el mercado: identificación de zonas clave, tendencias multi-timeframe, áreas de interés y mucho más",
        landing_feature_detail_scan_auto: "Escaneo automático cada 15 minutos",
        landing_feature_detail_symbols_parallel: "50+ símbolos analizados en paralelo",
        landing_feature_detail_leaderboard_realtime: "Tabla de clasificación actualizada en tiempo real",
        landing_feature_detail_filters: "Filtros avanzados para configuraciones calificadas",
        landing_feature_detail_4_strategies: "4 estrategias listas para usar",
        landing_feature_detail_more_coming: "Nuevas estrategias próximamente",
        landing_feature_detail_custom_params: "Parámetros personalizados por estrategia",
        landing_feature_detail_auto_switch: "Cambio de estrategia instantáneo",
        landing_feature_detail_auto_tpsl: "Cálculo automático de TP/SL",
        landing_feature_detail_auto_sltp: "Stop Loss y Take Profit automáticos",
        landing_feature_detail_asset_adaptation: "Adaptación automática para activo",
        landing_feature_detail_websocket: "Conexión WebSocket en tiempo real",
        landing_feature_detail_instant_notifications: "Notificaciones instantáneas",
        landing_feature_detail_checklist_12: "Lista de verificación IA de 12 puntos",
        landing_feature_detail_backtest: "Backtesting avanzado",
        landing_feature_detail_exportable_pdf: "Informes exportables en PDF",
        landing_assets_title: "Activos",
        landing_assets_supported: "Soportados",
        landing_assets_desc: "Soporte completo para Forex, Metales Preciosos, Criptomonedas e Índices",
        landing_assets_and_more: "Y mucho más",
        landing_assets_full_support: "con calculador de pips avanzado integrado",
        landing_how_it_works_title: "Cómo",
        landing_how_it_works_funziona: "Funciona",
        landing_how_it_works_desc: "Cuatro pasos simples para comenzar a hacer trading profesional con IA",
        landing_use_cases_title: "Para",
        landing_use_cases_every_trader: "Cada Trader",
        landing_use_cases_desc: "Desde principiantes hasta profesionales, nuestra plataforma se adapta a tus necesidades",
        landing_testimonials_title: "Lo que Dicen los",
        landing_testimonials_traders: "Traders",
        landing_testimonials_desc: "Testimonios reales de traders que usan nuestra plataforma",
        landing_testimonials_plan_label: "Plan",
        landing_testimonials_active_traders: "Traders Activos",
        landing_testimonials_avg_rating: "Calificación Promedio",
        landing_testimonials_satisfaction: "Satisfacción",
        landing_tutorial_title: "Tutorial",
        landing_tutorial_step_by_step: "Paso a Paso",
        landing_tutorial_desc: "Aprende a usar todas las funcionalidades de la plataforma en pocos minutos",
        landing_tutorial_start: "Iniciar Tutorial",
        landing_pricing_title: "Planes y Precios",
        landing_pricing_subtitle: "Elige el plan perfecto para tus necesidades de trading",
        landing_pricing_free_name: "Gratis",
        landing_pricing_free_period: "Gratis para siempre",
        landing_pricing_free_desc: "Perfecto para empezar",
        landing_pricing_free_cta: "Empezar Gratis",
        landing_pricing_pro_name: "Pro",
        landing_pricing_pro_period: "€29/mes",
        landing_pricing_pro_desc: "Para traders serios",
        landing_pricing_pro_cta: "Elegir Pro",
        landing_pricing_advanced_name: "Avanzado",
        landing_pricing_advanced_period: "€29.90/mes",
        landing_pricing_advanced_desc: "Para profesionales",
        landing_pricing_advanced_cta: "Elegir Avanzado",
        landing_pricing_most_popular: "MÁS POPULAR",
        landing_pricing_secure: "Pago seguro y garantizado",
        landing_faqs_title: "Preguntas",
        landing_faqs_frequent: "Frecuentes",
        landing_faqs_desc: "Respuestas a las preguntas más comunes sobre nuestra plataforma",
        landing_cta_title: "¿Listo para Empezar?",
        landing_cta_subtitle: "Únete a miles de traders que usan nuestra plataforma todos los días",
        landing_footer_description: "Análisis de trading profesional powered by AI. Escáner automático, análisis multi-timeframe y 4 estrategias avanzadas.",
        landing_footer_product: "Producto",
        landing_footer_resources: "Recursos",
        landing_footer_documentation: "Documentación",
        landing_footer_api: "API",
        landing_footer_support: "Soporte",
        landing_footer_security: "Seguridad",
        landing_footer_encrypted_data: "Datos encriptados",
        landing_footer_gdpr: "Cumplimiento GDPR",
        landing_footer_secure_servers: "Servidores seguros",
        landing_footer_copyright: "© 2024 TradeAnalyzer Pro. Todos los derechos reservados.",
        landing_auth_back: "Volver al Inicio",
        landing_auth_create_account: "Crea tu cuenta",
        landing_auth_login_account: "Inicia sesión en tu cuenta",
        landing_auth_start_today: "Empieza hoy y transforma tu trading",
        landing_auth_welcome_back: "¡Bienvenido de nuevo! Inicia sesión para continuar",
        landing_auth_have_account: "¿Ya tienes una cuenta?",
        landing_auth_sign_in: "Iniciar Sesión",
        landing_auth_no_account: "¿No tienes una cuenta?",
        landing_auth_sign_up: "Regístrate",
        now: "Ahora"
    }
};

export const useTranslation = () => {
    let lang = 'it';
    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            lang = localStorage.getItem('app_language') || 'it';
        }
    } catch (e) {
        // Ignora errori localStorage
    }
    
    const t = (key) => {
        // Accedi direttamente all'oggetto translations esportato
        const trans = translations;
        
        if (!trans) {
            return key;
        }
        
        // Prima prova con la lingua corrente
        if (trans[lang] && trans[lang][key] !== undefined) {
            return trans[lang][key];
        }
        
        // Poi prova con italiano come fallback
        if (trans.it && trans.it[key] !== undefined) {
            return trans.it[key];
        }
        
        // Se non trova nulla, ritorna la chiave
        return key;
    };
    
    return { t, lang };
};
